import React from 'react'
import PhoneIcon from '@mui/icons-material/Phone';

import './PhoneNumber.scss'

const PhoneNumber = () => {
  return (
    <div className='phone'>
      <PhoneIcon className="phone_ico" />
      <a href="tel:8 800 222 57 53">8 800 222 57 53</a>
    </div>
  )
}

export default PhoneNumber